<template>
  <el-dropdown trigger="click" ref="drop" @visible-change="visibleChange" :disabled="disabled">
    <slot :selectColor="selectColor"></slot>
    <el-dropdown-menu slot="dropdown" class="color-control-dropdown">
      <div class="color-control-main">
        <div class="title">背景颜色</div>
        <div class="color-mini">
          <div class="color-mini-item" v-for="item in colorArray" :key="item.background_color" :class="{'check': item.background_color === selectColor.background_color}" @click="checkItem(item)">
            <img :src="item.backGroundMini" alt="">
          </div>
        </div>
        <div class="title">背景文本</div>
        <div class="color-text">
          <el-input placeholder="请输入项目名称，限制8个字符" maxlength="8" v-model="selectColor.background_text" @change="change" clearable></el-input>
        </div>
        <div class="title">背景预览</div>
        <div class="color-img">
          <img :src="selectColor.backGround" alt="">
          <span>{{selectColor.background_text || '项目名称'}}</span>
        </div>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { colorArray } from './color'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectColor: JSON.parse(JSON.stringify(colorArray[0])),
      colorArray: colorArray,
    }
  },
  created() {

  },
  mounted() {
  },
  watch: {
    dataset: {
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if(!this.dataset) this.change()
  },
  methods: {
    init() {
      if(this.dataset) {
        this.selectColor = JSON.parse(JSON.stringify((this.colorArray.find(res => res.background_color === this.dataset.background_color)) || this.colorArray[0]))
        this.selectColor.background_text = this.dataset.background_text
      }
    },
    checkItem(item) {
      this.selectColor.background_color = item.background_color
      this.selectColor.backGroundMini = item.backGroundMini
      this.selectColor.backGround = item.backGround
      this.change()
    },
    change() {
      let { background_color, background_text } = this.selectColor
      this.$emit('change', { background_color,  background_text})
    },
    visibleChange(val) {
      this.$emit('visible-change', val)
    }
  }
}
</script>
<style lang="scss">
.color-control-dropdown {
  max-height: auto;
  padding-top: 16px;
  padding-bottom: 24px;
}
.color-control {
  .el-dropdown-link {
    display: flex;
    align-items: center;
    img {
      margin-right: 9px;
      width: 32px;
      height: 32px;
      border-radius: 6px;
    }
    i {
      color: rgba(32, 32, 32, 0.6);
      font-size: 12px;
    }
  }
}
.color-control-main {
  padding: 0 24px;
  box-sizing: border-box;
  .title {
    color: rgba(32, 32, 32, 0.8);
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 8px;
    margin-top: 24px;
  }
  .title:first-child {
    margin-top: 0;
  }
  .color-mini {
    display: flex;
    align-items: center;
    .color-mini-item {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 8px;
      cursor: pointer;
      position: relative;
      color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
      &::before {
        content: '';
        font-family: 'iconfont';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 300;
        font-size: 14px;
      }
      &:hover {
        &::before {
          background-color: rgba(32, 32, 32, 0.16);
        }
      }
      &:active {
        &::before {
          background-color: rgba(32, 32, 32, 0.40);
        }
      }
      &.check {
        &::before {
          content: "\E7A7";
          background-color: rgba(32, 32, 32, 0.40);
        }
      }
    }
  }
  .color-img {
    width: 250px;
    height: 86px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      font-weight: 500;
      font-size: 28px;
      color: rgba(255, 255, 255, 0.8);
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
